import React, { useState } from 'react'
import VarietyList from './VarietyList'
import VarietyForm from './VarietyForm';

const Variety= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <VarietyForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <VarietyList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}
  
    </>
  )
}

export default Variety